import { render, staticRenderFns } from "./LlmSkuMountedModels.vue?vue&type=template&id=5235ba40"
import script from "./LlmSkuMountedModels.vue?vue&type=script&lang=js"
export * from "./LlmSkuMountedModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports